<template>
    <div style="height: 30vh;  margin: auto">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 20px">
            <el-col :xl="3" :lg="3" :md="3" :sm="3" :xs="3" style="line-height: 28px;text-align: right;margin-right: 10px;">机制：</el-col>
            <el-col :xl="19" :lg="19" :md="19" :sm="19" :xs="19">
                <el-radio-group  v-model="isMatches">
                    <el-radio label=true  style="margin-top: 7px;">匹配时执行</el-radio>
                    <el-radio label=false  style="margin-top: 7px;">不匹配时执行</el-radio>
                </el-radio-group>
            </el-col>
        </el-col>
        <condition-com v-for="(item,index) in deviceLinkageActions" :key="index" :item="item" :spaceList="spaceList" :index="index" :deviceLinkageActions="deviceLinkageActions" @deleteIndex="del"
                   @uploadData="getData" @add="add"></condition-com>
        <el-col :span="24" style="height: 8px;" class="hidden-sm-and-up"></el-col>
        <el-col :span="24" style="height: 13px;" class="hidden-md-and-down"></el-col>
    </div>
</template>

<script>
    import ConditionCom from "@/views/basic_operations/strategy/linkage/simple/edit/ConditionCom.vue";
    import {getSpaceTreeData} from '@/network/space-info';
    import lodash from "lodash";
    export default {
        name: "Condition",
        props:["dialogData"],
        components:{ConditionCom},
        data (){
            return {
                isMatches:"true",
                form:{
                    deviceLinkageActions:[],
                },
                deviceLinkageActions:[],
                deviceList:[
                ],
                pointList:[
                ],
                spaceList:[
                ],
                type: '',
            }
        },
        created() {
            this.getSpaceTreeData();
            this.add();
            if(this.dialogData && this.dialogData.length>0){
                this.isMatches=this.dialogData[0].isMatches+"";
                this.deviceLinkageActions=lodash.cloneDeep(this.dialogData);
            }
        },
        methods:{
            add(){
                let form={
                    isMatches:'',
                    spaceId:'',
                    spaceName:'',
                    deviceId:'',
                    deviceModelControlId:'',
                    deviceName:'',
                    devicePointId:'',
                    devicePointName:'',
                    pointValue:'',
                    channel:'',
                    // 设备类型
                    deviceType:''
                };
                this.deviceLinkageActions.push(form);
            },
            // delete
            del: function (index) {
              console.log(this.deviceLinkageActions);
              let deviceLinkageActionList = lodash.cloneDeep(this.deviceLinkageActions);
              deviceLinkageActionList.splice(index, 1);
              console.log(deviceLinkageActionList);
              this.deviceLinkageActions =[];
              console.log(deviceLinkageActionList);
              this.deviceLinkageActions = deviceLinkageActionList;
            },
            //  get the data from child
            getData: function (val) {
                let index = val.index;
                this.deviceLinkageActions[index] = val.data;
                this.type = val.type;
            },
            getForm(){
                console.log(this.deviceLinkageActions);
                for(let item of this.deviceLinkageActions){
                    item.isMatches=this.isMatches;
                    if(item.isMatches.length<=0){
                        this.$message.error("请选择是否匹配");
                        return null;
                    }
                    if(item.spaceName.length<=0){
                        this.$message.error("请选择空间");
                        return null;
                    }
                    if(item.deviceName.length<=0){
                        this.$message.error("请选择设备");
                        return null;
                    }
                    if(item.deviceType!='PM_Video' && item.deviceType!='Video_vlc' && item.deviceType!='PM_CAM' && item.deviceType!='PM_DVR'){
                        if(item.devicePointName.length<=0){
                            this.$message.error("请选择测点");
                            return null;
                        }
                        if(item.deviceModelControlId==undefined || item.deviceModelControlId.length<=0){
                            this.$message.error("请选择控制");
                            return null;
                        }
                        if(this.type=='text' && !this.$stringIsNotNullAndEmpty(item.pointValue)){
                            this.$message.error("请输入测点值");
                            return null;
                        }
                    }
                }
                this.form.deviceLinkageActions=this.deviceLinkageActions;
                return this.form.deviceLinkageActions;
            },
            getSpaceTreeData() {
                getSpaceTreeData().then(res => {
                    if (res.code === 0) {
                        // 将树转换成需要的格式
                        let tree = res.data;
                        this.spaceList = this.getTree(tree);
                    }
                });
            },
            getTree(tree) {
                // 返回的数组
                let treeList = [];
                for (let item of tree) {
                    // 创建上级选项
                    let param = {value: item.id, label: item.title};
                    if (item.children) {
                        // 给上级选项添加下级选项
                        param.children = this.getTree(item.children);
                    }
                    treeList.push(param)
                }
                return treeList;
            },
        }
    }
</script>

<style scoped>

</style>
<style>
</style>
